<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2124"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2128"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2138"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2136" /></clipPath></defs><g
     id="g2130"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2132"><g
         id="g2134"
         clip-path="url(#clipPath2138)"><g
           id="g2140"
           transform="translate(90,58)"><path
             d="m 0,0 v -8 c 0,-22.091 -17.909,-40 -40,-40 v 0 c -22.091,0 -40,17.909 -40,40 v 283.253"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2142" /></g><g
           id="g2144"
           transform="translate(382,10)"><path
             d="M 0,0 H -332"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2146" /></g><g
           id="g2148"
           transform="translate(90,58)"><path
             d="M 0,0 H 177"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2150" /></g><g
           id="g2152"
           transform="translate(235.9999,502)"><path
             d="M 0,0 H 146 V -204"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2154" /></g><g
           id="g2156"
           transform="translate(10,333.2534)"><path
             d="M 0,0 V 168.747 H 146"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2158" /></g><g
           id="g2160"
           transform="translate(196,502)"><path
             d="M 0,0 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2162" /></g><g
           id="g2164"
           transform="translate(470,10)"><path
             d="m 0,0 h -168 c -17.673,0 -32,14.327 -32,32 v 224 c 0,17.673 14.327,32 32,32 H 0 c 17.673,0 32,-14.327 32,-32 V 32 C 32,14.327 17.673,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2166" /></g><path
           d="M 458,198 H 313.958 v 56 H 458 Z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2168" /><g
           id="g2170"
           transform="translate(313.9583,162)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2172" /></g><g
           id="g2174"
           transform="translate(376.4583,162)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2176" /></g><g
           id="g2178"
           transform="translate(438.9583,162)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2180" /></g><g
           id="g2182"
           transform="translate(313.9583,125.3333)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2184" /></g><g
           id="g2186"
           transform="translate(376.4583,125.3333)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2188" /></g><g
           id="g2190"
           transform="translate(438.9583,125.3333)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2192" /></g><g
           id="g2194"
           transform="translate(313.9583,88.6667)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2196" /></g><g
           id="g2198"
           transform="translate(376.4583,88.6667)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2200" /></g><g
           id="g2202"
           transform="translate(438.9583,88.6667)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2204" /></g><g
           id="g2206"
           transform="translate(313.9583,52)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2208" /></g><g
           id="g2210"
           transform="translate(376.4583,52)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2212" /></g><g
           id="g2214"
           transform="translate(438.9583,52)"><path
             d="M 0,0 H 19.042"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2216" /></g><path
           d="M 112,400 H 64 v 48 h 48 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2218" /><path
           d="M 112,304 H 64 v 48 h 48 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2220" /><path
           d="M 112,208 H 64 v 48 h 48 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2222" /><path
           d="M 112,112 H 64 v 48 h 48 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2224" /><g
           id="g2226"
           transform="translate(178.4999,424)"><path
             d="M 0,0 H 122.5"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2228" /></g><g
           id="g2230"
           transform="translate(178.4999,328)"><path
             d="M 0,0 H 122.5"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2232" /></g><g
           id="g2234"
           transform="translate(178.4999,232)"><path
             d="M 0,0 H 88.5"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2236" /></g><g
           id="g2238"
           transform="translate(178.4999,136)"><path
             d="M 0,0 H 88.5"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2240" /></g></g></g></g></svg>
</template>
